(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SpokenLayer", [], factory);
	else if(typeof exports === 'object')
		exports["SpokenLayer"] = factory();
	else
		root["SpokenLayer"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition